// src/components/TablePagination.js
// Shared pagination:  1-10 of 604   [< Previous]   [Page 1 of 61]   [Next >]

import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const wrapStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: 14,
  margin: '18px 0 24px',
};

const infoStyle = {
  fontSize: 14,
  color: '#333',
  whiteSpace: 'nowrap',
};

const boxBase = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  padding: '9px 20px',
  border: '1px solid #dcdfe6',
  borderRadius: 6,
  background: '#fff',
  fontSize: 14,
  fontFamily: 'inherit',
  color: '#333',
};

const TablePagination = ({ page, totalItems, pageSize = 10, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil((totalItems || 0) / pageSize));
  const from = totalItems ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(page * pageSize, totalItems || 0);

  const prevDisabled = page <= 1;
  const nextDisabled = page >= totalPages;

  const navStyle = (disabled) => ({
    ...boxBase,
    cursor: disabled ? 'not-allowed' : 'pointer',
    color: disabled ? '#c0c4cc' : '#333',
    background: disabled ? '#fafafa' : '#fff',
  });

  return (
    <div style={wrapStyle}>
      <span style={infoStyle}>{from}-{to} of {totalItems || 0}</span>

      <button
        type="button"
        style={navStyle(prevDisabled)}
        disabled={prevDisabled}
        onClick={() => onPageChange(Math.max(1, page - 1))}
      >
        <FaChevronLeft size={11} /> Previous
      </button>

      <span style={{ ...boxBase, fontWeight: 700 }}>
        Page {page} of {totalPages}
      </span>

      <button
        type="button"
        style={navStyle(nextDisabled)}
        disabled={nextDisabled}
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
      >
        Next <FaChevronRight size={11} />
      </button>
    </div>
  );
};

export default TablePagination;